import DateFormat from '@/Enums/Format/DateFormat.enum';
import { DateRange } from '@mui/x-date-pickers-pro';
import moment, { Moment, MomentInput } from 'moment';

export const dateRangeToFormat = (
  dateRange: [Moment, Moment] | DateRange<Moment>,
  format: DateFormat = DateFormat.DayShortMonthYear,
) => {
  return dateRange.map(date => (date?.isValid() ? date.format(format) : '-')).join(' - ');
};

/**Format date. Useful for display uses, not so much for API requests. */
export const dateToFormat = (date: MomentInput, format: DateFormat, fallbackDisplay: string = '-') => {
  if (!date) return fallbackDisplay;
  const momentDate = moment.utc(date);
  if (!momentDate.isValid()) return fallbackDisplay;
  return momentDate.format(format);
};

/**Format date to `DateFormat.NumericMonthDayYear` */
export const dateToShortFormat = (date: MomentInput, fallbackDisplay: string = '-') => {
  if (!date) return fallbackDisplay;
  return dateToFormat(date, DateFormat.NumericMonthDayYear, fallbackDisplay);
};
